import React, { useEffect } from "react";
import { useConfig } from "@peracto/peracto-config";
import File from "@peracto/peracto-editor-ui/dist/File";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";

import startCase from "lodash/startCase";

const CarouselForm = ({
    onChange,
    state: { images = [], selectedImageIndex },
}) => {
    const DEFAULT_IMAGE = {
        url: "https://via.placeholder.com/600x200",
        openInNewTab: false,
    };

    const config = useConfig();
    const { theme } = config.get("editorConfig") || [];

    const themeColours = [];

    if (theme?.colors?.brand) {
        for (const [label, colour] of Object.entries(theme.colors.brand)) {
            themeColours.push({
                label: startCase(label),
                value: colour,
            });
        }
    }

    useEffect(() => {
        return () => {
            onChange({ selectedImageIndex: 0 });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex flex-col gap-[5px]">
            <p>Images</p>
            {images?.length > 0 &&
                images.map((image, index) => {
                    return (
                        <div className="flex flex-row justify-between items-start gap-[5px]">
                            <File
                                onChange={(value) => {
                                    const imagesClone = [...images];
                                    imagesClone[index].url = value;
                                    onChange({
                                        images: imagesClone,
                                    });
                                }}
                                value={image.url || ""}
                                isInline={true}
                            />

                            <button
                                className="btn btn-sm btn-danger flex h-[28px] items-center justify-center"
                                disabled={images.length === 1}
                                onClick={(e) => {
                                    const imagesClone = [...images];

                                    imagesClone.splice(selectedImageIndex, 1);

                                    onChange({
                                        images: imagesClone,
                                    });
                                    onChange({
                                        selectedImageIndex:
                                            selectedImageIndex > 0
                                                ? selectedImageIndex - 1
                                                : 0,
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </div>
                    );
                })}

            <hr className="my-2" />

            <button
                className="btn btn-sm btn-secondary w-100"
                onClick={(e) => {
                    const imagesClone = [...images, DEFAULT_IMAGE];
                    onChange({
                        images: imagesClone,
                    });
                    onChange({
                        selectedImageIndex: imagesClone.length - 1,
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add
                Image
            </button>
        </div>
    );
};

export default CarouselForm;
